import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { analytics } from './services/analytics';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Core Web Vitals → OpenPanel (WEB-4044), matching the dashboard's
// web_vital event shape.
reportWebVitals((metric) => {
  analytics.track("web_vital", {
    metric: metric.name as "LCP" | "CLS" | "INP" | "TTFB" | "FCP" | "FID",
    value: Math.round(metric.value * 1000) / 1000,
  });
});
